module.exports = "https://media.zlongame.com/media/pictures/cn/vipCenter/assets/img/m/zl/bottommenu/home_on.png";